
import * as React from "react";

// Copied from shadcn/ui sidebar constants, assuming 'md' breakpoint is 768px
const MOBILE_MAX_WIDTH = 768;

export function useIsMobile(maxWidth: number = MOBILE_MAX_WIDTH) {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < maxWidth);
    };

    // Initial check
    checkDevice();

    // Listener for window resize
    window.addEventListener("resize", checkDevice);

    // Cleanup listener
    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, [maxWidth]);

  return isMobile;
}

